//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
//轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

export default {
    name: 'carrousel',
    props:['imgArr'],
    data() {
      return {
        swiperOption: {
          // spaceBetween: 30,
          loop: true,
          init:false,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    },
    computed: {
      swiper(){
        return this.$refs.myswiper.swiper;
      }
    },
    updated() {
      console.log(this.imgArr);
      if (this.imgArr.length>1) {
        console.log(this.swiper);
        this.swiper.init();
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/swiper/carousel.vue